import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import PrinterLine from "@store/Components/Icons/Printer/PrinterLine";
import { actionLinkStyles, scalableIconStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export const printButton = () => {
    return {
        icon: {
            iconProps: {
                src: PrinterLine,
                css: css`
                    ${scalableIconStyles()}
                    font-size: 1.5em;
                    margin-right: 0.3em;
                    transition: inherit !important;
                `,
            },
        },
        css: css`
            ${actionLinkStyles()}
            display: block;

            ${IconWrapper} {
                color: ${getColor("primary")};
            }
        `,
    };
};
